import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";

class AuthService {

    static login(item) {
        return axiosInstance
            .post(API_BASE_URL + API_PATHS.adminlogin, item)
            .then((response) => {
                if (response?.data?.status === 1) {
                    localStorage.setItem(
                        "user",
                        JSON.stringify(response.data)
                    );
                    localStorage.setItem(
                        "accessToken",
                        response.data.data.accessToken
                    );
                    localStorage.setItem(
                        "refreshToken",
                        response.data.data.refreshToken
                    );

                    return response.data;
                }

                throw new Error(
                    response?.data?.message || "Invalid credentials"
                );
            });
    }

    static userLogin(item) {
        return axiosInstance
            .post(API_BASE_URL + API_PATHS.userlogin, item)
            .then((response) => {
                if (response?.data?.status === 1) {
                    localStorage.setItem(
                        "user",
                        JSON.stringify(response.data)
                    );
                    localStorage.setItem(
                        "accessToken",
                        response.data.data.accessToken
                    );
                    localStorage.setItem(
                        "refreshToken",
                        response.data.data.refreshToken
                    );

                    return response.data;
                }

                throw new Error(
                    response?.data?.message || "Invalid credentials"
                );
            });
    }

    static register(item) {
        return axiosInstance.post(
            API_BASE_URL + API_PATHS.register,
            item
        );
    }

    static verifyotp(item) {
        return axiosInstance
            .post(
                API_BASE_URL + API_PATHS.verifyotp,
                item
            )
            .then((response) => {
                if (response?.data?.status === 1) {
                    localStorage.setItem(
                        "user",
                        JSON.stringify(response.data)
                    );

                    localStorage.setItem(
                        "accessToken",
                        response.data.data.accessToken
                    );

                    localStorage.setItem(
                        "refreshToken",
                        response.data.data.refreshToken
                    );

                    return response.data;
                }

                throw new Error(
                    response?.data?.message || "Invalid credentials"
                );
            });
    }

    static forgotPassword(item) {
        return axiosInstance.post(
            `${API_BASE_URL}${API_PATHS.forgotpassword} `,
            item
        );
    }

    static setPassword(item) {
        return axiosInstance.post(
            `${API_BASE_URL}${API_PATHS.setpassword} `,
            item
        );
    }

    static editProfile(item) {
        return axiosInstance.put(
            `${API_BASE_URL}${API_PATHS.editprofile} `,
            item
        );
    }

    static getProfile() {
        return axiosInstance.get(
            `${API_BASE_URL}${API_PATHS.getProfile} `
        );
    }

    static getAminity() {
        return axiosInstance.get(
            `${API_BASE_URL}${API_PATHS.getAmenity} `
        );
    }

    static getRoles() {
        return axiosInstance.get(
            `${API_BASE_URL}${API_PATHS.getRoles} `
        );
    }

    static getStats(item) {
        return axiosInstance.get(
            `${API_BASE_URL}${API_PATHS.orggetStats}?range = ${item.range}& orgId=${item.orgId} `
        );
    }

    static getCounts(item) {
        return axiosInstance.get(
            `${API_BASE_URL}${API_PATHS.orggetDashCount}?range = ${item.range}& orgId=${item.orgId} `
        );
    }

    // Logout and remove all authentication details
    static logout() {
        localStorage.removeItem("user");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
    }

    // Get logged-in user details
    static getUserDetails() {
        const user = localStorage.getItem("user");

        try {
            return user ? JSON.parse(user) : null;
        } catch (e) {
            console.error(
                "Error parsing user details from localStorage",
                e
            );

            return null;
        }
    }

    // Set authentication tokens
    static setTokens(data) {
        localStorage.setItem(
            "accessToken",
            data.data.accessToken
        );

        localStorage.setItem(
            "refreshToken",
            data.data.refreshToken
        );
    }
}

export default AuthService;

